export const SERVICE_NAMES: TStringObject = {
  top3: 'Топ-объявлений',
  'premium+highlight': `Премиум-объявлений`,
  premium: 'Премиум-объявлений',
  'paid+highlight': `Платных объявлений`,
  paid: 'Платных объявлений',
  free: 'Бесплатных объявлений',
};
